/* eslint-disable react/jsx-no-bind */
/* eslint-disable import/no-named-as-default */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-console */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useStaticQuery, graphql } from 'gatsby'
import { v4 } from 'uuid'

// Components
import Select from 'react-select'
import Content from './shared/Content'
import Loading from './shared/Loading'
import ButtonDefault from './elements/ButtonDefault'

// Third Party

const StyledForm = styled.form`
  position: relative;
`

const ConfirmationMessage = styled(Content)`
  font-size: ${(props) => props.theme.font.size.l};
  text-align: center;
`

const Label = styled.label`
  display: block;
  font-style: italic;
  color: ${(props) => props.theme.color.text.contrast};

  @media (min-width: 992px) {
    font-size: ${(props) => props.theme.font.size.xm};
  }

  @media (max-width: 991px) {
    font-size: ${(props) => props.theme.font.size.m};
  }
`

const Input = styled.input`
  border: 1px solid ${(props) => props.theme.color.grey};
  text-indent: 10px;
  width: 90%;
  height: 41px;
  font-size: 16px;
  text-indent: 15px;
  font-style: italic;

  @media (max-width: 991.98px) {
    width: 100%;
  }
`

const Textarea = styled.textarea`
  border: 1px solid ${(props) => props.theme.color.grey};
  width: 90%;
  font-size: 16px;
  height: 145px;
  text-indent: 15px;
  font-style: italic;
  padding-top: 10px;

  @media (max-width: 991.98px) {
    width: 100%;
  }
`

const Mandatory = styled.span`
  font-size: ${(props) => props.theme.font.size.xm};
  color: ${(props) => props.theme.color.contrast};
  margin-left: 5px;
`

const Button = styled.div`
  margin-right: 10%;

  & .form-button {
    &::after {
      display: none;
    }
  }
  @media (max-width: 991.98px) {
    margin-right: 0;
  }
`

function GravityForm({ id, defaultValues = {} }) {
  const {
    allGfForm: { edges: gravityData },
  } = useStaticQuery(graphql`
    query {
      allGfForm {
        edges {
          node {
            formId
            slug
            apiURL
            descriptionPlacement
            formFields {
              id
              label
              labelPlacement
              description
              descriptionPlacement
              type
              choices
              content
              errorMessage
              inputMaskValue
              isRequired
              visibility
              cssClass
              placeholder
              size
              defaultValue
              maxLength
            }
            button {
              text
            }
            confirmations {
              message
            }
          }
        }
      }
    }
  `)

  const { node: gfForm } = gravityData.filter(
    ({ node }) => node.formId === id
  )[0]

  const [fields, setFields] = useState(defaultValues)
  const [form, setForm] = useState(gfForm)
  const [status, setStatus] = useState('')
  const [message, setMessage] = useState('')

  useEffect(() => {
    const tempForm = form

    // add submit button as a field
    if (
      tempForm.formFields.filter((item) => item.type === 'submit').length === 0
    ) {
      tempForm.formFields = [
        ...tempForm.formFields,
        {
          formId: v4(),
          type: 'submit',
          text: tempForm.button.text,
        },
      ]
    }

    setForm({
      ...form,
      ...tempForm,
    })
  }, [])

  console.log(form);

  async function handleOnSubmit(event) {
    event.preventDefault()

    if (status === 'processing') {
      return
    }

    setStatus('processing')

    try {
      const formData = new FormData()

      if (defaultValues) {
        for (const [key, value] of Object.entries(defaultValues)) {
          formData.append(key, value)
        }
      }

      for (const [key, value] of Object.entries(fields)) {
        formData.append(key, value)
      }

      const request = await fetch(`${form.apiURL}/submissions`, {
        method: 'POST',
        body: formData,
      })

      const response = await request.json()
      if (response.is_valid === true) {
        setStatus('done')

        setMessage(response.confirmation_message)
      } else {
        setStatus('error')
      }
    } catch (error) {
      setStatus('error')
      console.error(error)
    }
  }

  function handleFieldChange(event) {
    // eslint-disable-next-line prefer-destructuring
    let { value } = event.target || event.value

    if (event.target) {
      if (event.target.type === 'checkbox') {
        value = event.target.checked ? event.target.value : ''
      }

      setFields({
        ...fields,
        [event.target.name]: value,
      })
    } else {
      setFields({
        ...fields,
        [event.name]: event.value,
      })
    }
  }

  if (status === 'done') {
    return <ConfirmationMessage content={message} />
  }

  if (form.formFields) {
    return (
      <StyledForm
        id={`form_${id}`}
        method="post"
        onSubmit={() => handleOnSubmit()}
      >
        {status === 'processing' && <Loading />}
        {form.formFields &&
          form.formFields.map((field, key) => {
            if (Array.isArray(field)) {
              return (
                <div key={key}>
                  {field.map((item, index) => (
                    <FormField
                      key={index}
                      field={item}
                      fields={fields}
                      onChange={handleFieldChange}
                    />
                  ))}
                </div>
              )
            }

            return (
              <div key={key}>
                <FormField
                  field={field}
                  fields={fields}
                  onChange={handleFieldChange}
                />
              </div>
            )
          })}
      </StyledForm>
    )
  }

  console.error('No gravity forms found with id', id)
  return false
}

function TextField({
  value,
  onChange,
  field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass },
}) {
  return (
    <div className="form-group mb-4">
      {labelPlacement !== 'hidden_label' && (
        <Label htmlFor={`input_${id}`}>
          {label}
          {isRequired && <Mandatory>*</Mandatory>}
        </Label>
      )}
      <Input
        value={value || ' '}
        onChange={onChange}
        type="text"
        id={`input_${id}`}
        className={`${type} ${cssClass !== undefined ? cssClass : ''}`}
        name={`input_${id}`}
        required={isRequired}
        placeholder={placeholder}
      />
    </div>
  )
}

function EmailField({
  value,
  onChange,
  field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass },
}) {
  return (
    <div className="form-group mb-4">
      {labelPlacement !== 'hidden_label' && (
        <Label htmlFor={`input_${id}`}>
          {label}
          {isRequired && <Mandatory>*</Mandatory>}
        </Label>
      )}
      <Input
        value={value}
        onChange={onChange}
        type="email"
        id={`input_${id}`}
        className={`${type} ${cssClass !== undefined ? cssClass : ''}`}
        name={`input_${id}`}
        required={isRequired}
        placeholder={placeholder}
      />
    </div>
  )
}

function PhoneField({
  value,
  onChange,
  field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass },
}) {
  return (
    <div className="form-group">
      {labelPlacement !== 'hidden_label' && (
        <Label htmlFor={`input_${id}`}>
          {label}
          {isRequired && <Mandatory>*</Mandatory>}
        </Label>
      )}
      <Input
        value={value}
        onChange={onChange}
        type="tel"
        id={`input_${id}`}
        className={`${type} ${cssClass !== undefined ? cssClass : ''}`}
        name={`input_${id}`}
        required={isRequired}
        placeholder={placeholder}
      />
    </div>
  )
}

function TextAreaField({
  value,
  onChange,
  field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass },
}) {
  return (
    <div className="form-group">
      {labelPlacement !== 'hidden_label' && (
        <Label htmlFor={`input_${id}`}>
          {label}
          {isRequired && <Mandatory>*</Mandatory>}
        </Label>
      )}
      <Textarea
        value={value}
        onChange={onChange}
        id={`input_${id}`}
        className={`${type} ${cssClass !== undefined ? cssClass : ''}`}
        name={`input_${id}`}
        required={isRequired}
        placeholder={placeholder}
      />
    </div>
  )
}

function CheckboxField({
  value,
  onChange,
  field: { id, type, cssClass, choices },
}) {
  const list = JSON.parse(choices)

  return (
    <div className="form-group">
      {list.map((checkbox, key) => (
        <div key={key} className="form-group__checkboxes">
          <input
            checked={value}
            onChange={onChange}
            type="checkbox"
            id={`input_${id}_${key + 1}`}
            className={`${type} ${cssClass !== undefined ? cssClass : ''}`}
            name={`input_${id}_${key + 1}`}
            value={checkbox.value}
          />
          <label
            htmlFor={`input_${id}_${key + 1}`}
            className="checkbox-content"
          >
            {checkbox.text}
          </label>
        </div>
      ))}
    </div>
  )
}

const StyledSelect = styled.div``

// Select or Dropdown
function SelectField({ field, onChange, value }) {
  // Populate a options array
  const options = []
  JSON.parse(field.choices).forEach((choice) => {
    options.push({
      value: choice.value,
      label: choice.text,
      type: 'select',
      name: `input_${field.id}`,
    })
  })

  // Custom Select component
  // eslint-disable-next-line react/no-unstable-nested-components
  function MySelect(props) {
    return (
      <Select
        {...props}
        onChange={props.onChange}
        options={props.options}
        placeholder={props.placeholder}
      />
    )
  }

  return (
    <StyledSelect>
      <MySelect
        options={options}
        onChange={onChange}
        value={options.filter((option) => option.value === value)}
        placeholder={field.label}
        classNamePrefix="react-select"
      />
    </StyledSelect>
  )
}

function SubmitButton({ field }) {
  return (
    <Button className="mt-5 float-right">
      <ButtonDefault wedgeColor="transparent" isCustom>
        <button type="submit">{field.text}</button>
      </ButtonDefault>
    </Button>
  )
}

function FileField({
  value,
  onChange,
  field: { id, type, label, labelPlacement, allowedExtensions, cssClass },
}) {
  function handleChange(file) {
    onChange({
      target: {
        name: `input_${id}`,
        value: file,
      },
    })
  }

  function handleFileUpload(e) {
    const {
      target: { files },
    } = e
    for (let i = 0; i < files.length; i += 1) {
      handleChange(files[i])
    }
  }

  function handleFileDrop(e) {
    e.preventDefault()

    if (e.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      for (let i = 0; i < e.dataTransfer.items.length; i += 1) {
        // If dropped items aren't files, reject them
        if (e.dataTransfer.items[i].kind === 'file') {
          handleChange(e.dataTransfer.items[i].getAsFile())
        }
      }
    } else {
      // Use DataTransfer interface to access the file(s)
      for (let i = 0; i < e.dataTransfer.files.length; i += 1) {
        handleChange(e.dataTransfer.files[i])
      }
    }
  }

  return (
    <div
      className="form-upload mb-4"
      onDrop={handleFileDrop}
      onDragOver={(e) => e.preventDefault()}
    >
      {labelPlacement !== 'hidden_label' && (
        <Label htmlFor={`input_${id}`}>{value ? value.name : label}</Label>
      )}

      <input
        type="file"
        onChange={handleFileUpload}
        id={`input_${id}`}
        className={`${type} ${cssClass !== undefined ? cssClass : ''}`}
        name={`input_${id}`}
        // placeholder={placeholder}
        accept={allowedExtensions}
      />
    </div>
  )
}

export function FormField({ field, fields, onChange }) {
  return (
    <>
      {field.type === 'text' && (
        <TextField
          onChange={onChange}
          value={fields[`input_${field.id}`]}
          field={field}
        />
      )}
      {field.type === 'email' && (
        <EmailField
          onChange={onChange}
          value={fields[`input_${field.id}`]}
          field={field}
        />
      )}
      {field.type === 'phone' && (
        <PhoneField
          onChange={onChange}
          value={fields[`input_${field.id}`]}
          field={field}
        />
      )}
      {field.type === 'textarea' && (
        <TextAreaField
          onChange={onChange}
          value={fields[`input_${field.id}`]}
          field={field}
        />
      )}
      {field.type === 'checkbox' && (
        <CheckboxField
          onChange={onChange}
          value={fields[`input_${field.id}`]}
          field={field}
        />
      )}
      {field.type === 'select' && (
        <SelectField
          onChange={onChange}
          value={fields[`input_${field.id}`]}
          field={field}
        />
      )}
      {field.type === 'fileupload' && (
        <FileField
          onChange={onChange}
          value={fields[`input_${field.id}`]}
          field={field}
        />
      )}
      {field.type === 'submit' && <SubmitButton field={field} />}
    </>
  )
}

export default GravityForm
